export default "__VITE_ASSET__D64CtgS2__"